import { Component, ChangeDetectionStrategy } from '@angular/core';

import { MdwButton } from '@spaces-ui/meadow/components/button';
import { MdwIcon } from '@spaces-ui/meadow/icons';
import { Apple_Fill } from '@spaces-ui/meadow/icons/svgs';

import { Sample } from '../../components';

@Component({
  selector: 'app-icon-callouts',
  imports: [Sample, MdwButton, MdwIcon],
  templateUrl: './icon-callouts.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './icon-callouts.scss',
})
export class IconCallouts {
  public icons = { Apple_Fill };
}
